<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
    <TutorialHost />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TutorialHost from '@/components/tutorial/TutorialHost.vue';
import { ensurePushListeners } from '@/services/PushNotificationsService';
import { consumeLaunchUrl, ensureUniversalLinkListener } from '@/services/universalLinks';
import { isJwtExpired, routeRequiresAuth, scheduleSessionExpiryLogout } from '@/utils/authSession';

export default {
  name: 'App',
  components: { TutorialHost },
  methods: {
    ...mapActions(['fetchEntitlements'])
  },
  watch: {
    '$store.state.token'(token, previous) {
      if (token && token !== previous) {
        this.$store.dispatch('fetchEntitlements');
      }
    }
  },
  async mounted() {
    ensurePushListeners(this);
    ensureUniversalLinkListener(this.$router);
    const token = this.$store.state.token;
    if (token && isJwtExpired(token)) {
      this.$store.commit('LOGOUT');
    }
    await consumeLaunchUrl(this.$router);
    const route = this.$router.currentRoute.value;
    if (routeRequiresAuth(route) && !this.$store.state.token) {
      this.$router.push('/login');
      return;
    }
    const liveToken = this.$store.state.token;
    if (!liveToken) return;
    scheduleSessionExpiryLogout(liveToken);
    await this.$store.dispatch('fetchEntitlements');
  }
}
</script>

<style>
:root {
  --bst-mobile-nav-content: 90px;
  --bst-mobile-nav-offset: calc(var(--bst-mobile-nav-content) + env(safe-area-inset-top, 0px));
}

#app {
  font-family:  'Titillium Web', Avenir, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: start;
  color: #2c3e50;
  min-height: 100vh;
  width: 100%;
}
body {
  margin: 0px;
  min-height: 100vh;
  width: 100%;
}
/* Screen-reader only utility class */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
